module.exports = __webpack_public_path__ + "static/media/interactionWithUniversity.72e11541.svg";